import HCheckArray from "@rf-helper/check-have-value";
import { C_BUSINESS_TYPE } from "@/src-refactor/modules/shared/model/const/property/business-type.const";
import { IPropertyForm } from "../../components/property-form/util/schemas/property-schema/propertySchema";

 const SeoGenerateAdapter = (ctx: IPropertyForm) => {
  const businessType = prepareGetBusinessType(ctx);
  const price = prepareGetPrice(ctx);
  const currency = prepareGetCurrency(ctx);
  return {
    type: (HCheckArray(ctx.type_property) && ctx.type_property[0].value as string) || "",
    name: ctx.name_property || "",
    city_name: (HCheckArray(ctx.city_property) && ctx.city_property[0].label) || "",
    sector_name:
      (HCheckArray(ctx.sector_property) && ctx.sector_property[0].label) || "",
    features:
      (HCheckArray(ctx.features_property) &&
        ctx.features_property.map((f: any) => f.label)) ||
      [],
    price,
    currency,

    bedrooms: (ctx.bedrooms_property && ctx.bedrooms_property[0]) || 0,
    bathrooms: (ctx.bathrooms_property && ctx.bathrooms_property[0]) || 0,
    parkings: (ctx.parking_spots_property && ctx.parking_spots_property[0]) || 0,
    construction_sqm:
      (ctx.meter_construction_property &&
        parseInt(ctx.meter_construction_property)) ||
      0,
    sqm_land: (ctx.meter_land_property && parseInt(ctx.meter_land_property)) || 0
  };
};

export default SeoGenerateAdapter;

const prepareGetBusinessType = (ctx: IPropertyForm) => {
  return (
    (HCheckArray(ctx.business_types_property) &&
      ctx.business_types_property[0].id) ||
    ""
  );
};
const prepareGetPrice = (ctx: IPropertyForm) => {
  if (HCheckArray(ctx.business_types_property)) {
    if (ctx.business_types_property[0].id == C_BUSINESS_TYPE.SALE.id) {
      return ctx.price_sale_property || "";
    } else if (ctx.business_types_property[0].id == C_BUSINESS_TYPE.SELL.id) {
      return ctx.price_rent_property || "";
    } else {
      return "";
    }
  }
  return "";
};

// currency
const prepareGetCurrency = (ctx: IPropertyForm) => {
  if (
    HCheckArray(ctx.currency_sale_property) &&
    HCheckArray(ctx.business_types_property)
  ) {
    if (ctx.business_types_property[0].id == C_BUSINESS_TYPE.SALE.id) {
      return ctx.currency_sale_property[0].label || "";
    } else if (ctx.business_types_property[0].id == C_BUSINESS_TYPE.SELL.id) {
      return ctx.currency_rent_property[0].label || "";
    } else {
      return "";
    }
  }
  return "";
};
